import React from 'react';

const AdsContext = React.createContext([]);

export default AdsContext;